export const contentAllowedBR = {
  1: 'Somente conteúdos livres',
  2: 'Até 10 anos',
  3: 'Até 12 anos',
  4: 'Até 14 anos',
  5: 'Até 16 anos',
  6: 'Todos os conteúdos',
};
